import { useCurrentEuiBreakpoint } from '@elastic/eui'

export const useScreenSize = () => {
    const size = useCurrentEuiBreakpoint()
    return {
        isMobile: size === 'xs' || size === 's',
        isTablet: size === 'm',
        isDesktop: size === 'xl' || size === 'l',
        size,
    }
}
